export const GET_SWITCHES_VALUES = 'GET_SWITCHES_VALUES';
export const SET_SHOW_SECTION = 'SET_SHOW_SECTION';
export const SET_FILTER_NAME = 'SET_FILTER_NAME';
export const CLEAN_SWITCHES_STATES = 'CLEAN_SWITCHES_STATES';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const CHANGE_SETTING_LOCAL = 'CHANGE_SETTING_LOCAL';
export const SET_FETCHING = 'SET_FETCHING';